import { PayloadAction } from '@reduxjs/toolkit';
import { viewersApi } from 'api/viewUserApi';
import { ListParams } from 'models';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ViewersActions } from './ViewerSlide';

function* addPlantsToViewer(action: PayloadAction<ListParams>) {
  const { array, id } = action.payload;
  try {
    const callList = array.map((item: string) =>
      call(viewersApi.addPlantToViewer, { viewer_id: id, plant_id: item })
    );
    yield all(callList);
    yield put(ViewersActions.addPlantsToViewerSuccess());
  } catch (error) {
    yield put(ViewersActions.addPlantsToViewerFailed('Failed plants to viewer!'));
  }
}

export default function* ViewerSaga() {
  yield takeLatest(ViewersActions.addPlantsToViewer, addPlantsToViewer);
}
